import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class CustomerResource extends BaseCamelCasedResource {
    pk() {
        return this.key || "";
    }
}
CustomerResource.urlRoot = legacyApiResourceUrl("CustomerIDSearch/SelectCustomer/FindV2");
export { CustomerResource };
//# sourceMappingURL=CustomerResource.js.map